import { render, staticRenderFns } from "./MatrixPanel.vue?vue&type=template&id=0fdaa802"
import script from "./MatrixPanel.vue?vue&type=script&lang=js"
export * from "./MatrixPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports